import React from 'react';

/**
 * Presentational workspace dropdown for the EDNL page. The parent owns
 * loading, the full workspace list, and persistence (localStorage). This
 * component just renders one of three states: loading, empty (user has no
 * workspaces), or a select control bound to `value` / `onChange`.
 */
export default function WorkspacePicker({ workspaces, value, loading, onChange }) {
  if (loading) {
    return (
      <div
        className="ednl-workspace-picker"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: '8px 0 12px 0',
          color: '#6b7280',
        }}
      >
        Loading workspaces...
      </div>
    );
  }

  if (!workspaces || workspaces.length === 0) {
    return (
      <div
        className="ednl-inline-alert ednl-inline-alert--warning"
        role="alert"
        style={{ margin: '8px 0 12px 0' }}
      >
        You do not have access to any workspaces yet. Create one in{' '}
        <strong>User Home &gt; Workspace Management</strong>.
      </div>
    );
  }

  return (
    <div
      className="ednl-workspace-picker"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        margin: '8px 0 12px 0',
      }}
    >
      <label
        htmlFor="ednl-workspace-picker-select"
        className="ednl-label"
        style={{ textTransform: 'none', letterSpacing: 'normal' }}
      >
        Workspace:
      </label>
      <select
        id="ednl-workspace-picker-select"
        className="ednl-input"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{ maxWidth: 420 }}
      >
        {!value && <option value="">Select a workspace…</option>}
        {workspaces.map((w) => (
          <option key={w.workspaceId} value={w.workspaceId}>
            {w.workspaceName} ({String(w.workspaceId).slice(0, 8)}…)
          </option>
        ))}
      </select>
    </div>
  );
}
